<template>
<svg viewBox="0 0 12 12" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-stop`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_d37fa5fc29__clip0_9683_2600)"><path d="M5.99963 0.562134C9.00252 0.562266 11.4379 2.99678 11.4381 5.99963C11.4381 9.00268 9.00265 11.438 5.99963 11.4381C2.99671 11.4379 0.562152 9.00261 0.562134 5.99963C0.562374 2.99684 2.99684 0.562374 5.99963 0.562134ZM5.99963 1.56018C3.54775 1.56042 1.56042 3.54775 1.56018 5.99963C1.5602 8.45171 3.54761 10.4398 5.99963 10.4401C8.45175 10.4399 10.44 8.45178 10.4401 5.99963C10.4398 3.54768 8.45161 1.56031 5.99963 1.56018ZM8.31995 5.50061C8.59501 5.50091 8.81777 5.72456 8.81799 5.99963C8.81799 6.2749 8.59514 6.49836 8.31995 6.49866H3.6803C3.40485 6.49866 3.18127 6.27509 3.18127 5.99963C3.1815 5.72437 3.40498 5.50061 3.6803 5.50061H8.31995Z"/></g><defs><clipPath id="svg_d37fa5fc29__clip0_9683_2600"><path d="M0 0H12V12H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconLineStop',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
